<section id="content">
    <div class="row">
        <div class="col-md-12 col-xs-12 table-cont">
            <div class="form-group">
                <div class="card">
                    <div class="card-title">
                        <h2>Product Module</h2>
                    </div>

                    <div class="cont">
                        <div class="group">
                            <div class="collapse-title">
                                Product Module
                                <i class="collapse-icon fa"></i>
                            </div>
                            <div class="collapse in show" id="ProductTrack">
                                <div class="group-cont">
                                    <div class="table-respnsive">
                                        <p-treeTable [value]="files" [columns]="cols" [scrollable]="true"
                                            [tableStyle]="{ 'min-width': '50rem' }" [paginator]="true" [rows]="10"
                                            [rowsPerPageOptions]="[5, 10, 25]" sortMode="multiple"
                                            styleClass="ui-table-customers" tableStyleClass="table table-respnsive">
                                            <!-- Caption -->

                                            <ng-template pTemplate="caption">
                                                <div class="flex">
                                                    <p-button label="Add Product Module" [outlined]="true"
                                                        icon="pi pi-plus-circle"
                                                        (onClick)="showDialogForCreateOrUpdate()"></p-button>
                                                </div>

                                            </ng-template>
                                            <!-- Header -->
                                            <ng-template pTemplate="header" let-columns>
                                                <tr>
                                                    <!-- Loop through the columns -->
                                                    <ng-container *ngFor="let col of columns; let i = index">

                                                        <th *ngIf="i === 0" width="5%">
                                                            #
                                                        </th>

                                                        <th *ngIf="i < columns.length - 1"
                                                            [ttSortableColumn]="col.field">
                                                            {{ col.header }}
                                                            <p-treeTableSortIcon [field]="col.field" />
                                                        </th>
                                                        <!-- Last column without sorting -->
                                                        <th *ngIf="i === columns.length - 1" width="10%">
                                                            {{ col.header }}
                                                        </th>

                                                    </ng-container>
                                                </tr>


                                            </ng-template>
                                            <!-- Body -->
                                            <ng-template pTemplate="body" let-rowNode let-rowData="rowData"
                                                let-columns="columns">
                                                <tr [ttRow]="rowNode">

                                                    <td *ngFor="let col of columns; let i = index; let last = last  let first = first">
                                                        <!-- Tree Table Toggler for the first column -->
                                                        
                                                
                                                        <p-treeTableToggler [rowNode]="rowNode"
                                                            *ngIf="i === 0"></p-treeTableToggler>
                                                        <!-- Row Data -->
                                                        
                                                        {{ rowData[col.field] }}
                                                        <!-- Action Buttons in the last column -->
                                                        <ng-container ng-container *ngIf="last">
                                                            <!-- <p-button icon="pi pi-search" rounded="true"
                                                                [style]="{ 'margin-right': '.5em', 'margin-left': '.5em' }"
                                                                (click)="showDialog(rowData.partNumber)">
                                                            </p-button> -->
                                                            <p-button icon="pi pi-pencil" rounded="true"
                                                                severity="success" (onClick)="showEditDialog(rowNode)">
                                                            </p-button>
                                                        </ng-container>
                                                    </td>
                                                </tr>
                                            </ng-template>
                                            <ng-template pTemplate="emptymessage">
                                                <tr>
                                                    <td colspan="9">No Order Found.</td>
                                                </tr>
                                            </ng-template>
                                        </p-treeTable>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>



<!-- dialog for add Or edit-->

<p-dialog [header]="dialogTitle" [modal]="true" [(visible)]="visibleDialog"
    [style]="{ width: '55rem', height: '34rem' }" styleClass="custom-dialog">
    
    <div class="dialog-content grid-container">
        <!-- First Column -->
        <div class="column">
            <div class="component">
                <app-products-lists [kind]="'all'" [(selectedCategory)]="selectedCategory"
                    [(selectedType)]="selectedType" [(selectedItem)]="selectedItem"
                    [(selectedProductId)]="selectedProductId"
                    (selectionChanged)="handleSelectionChanged($event)"></app-products-lists>
            </div>
        </div>

        <!-- Second Column -->
        <div class="column" style="margin: 2px;">
            <div class="form-group">
                <label for="customer">Module Name</label>
                <input pInputText id="moduleName" [(ngModel)]="MaoduleName" placeholder="Enter Module Name"
                    class="full-width" />
            </div>
            <div class="form-group">
                <label for="opp">Module Number</label>
                <input pInputText id="moduleNumber" [(ngModel)]="MaoduleNumber" placeholder="Enter Module Number"
                    class="full-width" />
            </div>
            <div class="form-group">
                <label for="opp">Parent Module</label>
                <p-dropdown id="opp" [options]="parentsOptions" placeholder="Select parent" class="full-width"
                    [(ngModel)]="selectedParent"
                    [disabled]="!parentsOptions || parentsOptions.length === 0" optionLabel="moduleName"
                    optionValue="id" [showClear]="true"></p-dropdown>
            </div>
        </div>

        <!-- Description Section Below the Columns -->
        <div class="description-section">
            <label for="stock">Description</label>
            <textarea rows="5" cols="80" pInputTextarea class="full-width"
                [(ngModel)]="description" placeholder="Enter Description"></textarea>
        </div>
    </div>

    <div class="dialog-footer">
        <p-button label="Cancel" severity="secondary" (onClick)="closeDialogCreateOrUpdate()"></p-button>
        <p-button label="Save" (onClick)="saveDialogCreateOrUpdate()"></p-button>
    </div>
</p-dialog>



<p-toast></p-toast>



<!-- dialog for sub product-->
<p-dialog header="Add Sub-Product" [modal]="true" [(visible)]="visible" [style]="{ width: '50rem' }"
    [breakpoints]="{ '1180px': '70vw', '560px': '80vw' }" styleClass="custom-dialog">

    <!-- PickList for selecting products -->
    <p-pickList [source]="sourceProducts" [target]="targetProducts" sourceHeader="Available" targetHeader="Selected"
        [dragdrop]="true" [responsive]="true" [sourceStyle]="{ height: '10rem' }" [targetStyle]="{ height: '10rem' }"
        filterBy="partNumber" sourceFilterPlaceholder="Search by part Number"
        targetFilterPlaceholder="Search by part Number" breakpoint="1400px">
        <ng-template let-product pTemplate="item">
            <div class="flex flex-wrap p-2 align-items-center gap-3 custom-item">
                <div class="flex-1 flex flex-column gap-2">
                    <span class="font-bold">{{ product.partNumber }}</span>
                    <div class="flex align-items-center gap-2">
                        <span>{{ product.description }}</span>
                    </div>
                </div>
            </div>
        </ng-template>
    </p-pickList>

    <!-- Button container aligned to the right -->
    <div class="button-container">
        <p-button label="Cancel" severity="secondary" (click)="visible = false"></p-button>
        <p-button label="Save" (click)="saveSelectedProduct()"></p-button>
    </div>
</p-dialog>